import { TypedRootState } from '../types';

export const selectModals = (state: TypedRootState) => state.modals;
